import { Button } from "@sellar-io/components";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { v4 } from "uuid";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { ORDER_RULE } from "../../../../constants/routes";
import { formatPriceInputToApi } from "../../../../hooks/usePriceFormat";
import { OrderRulesForm } from "./OrderRulesForm";
import { useOrderRulesCreate } from "../../../../hooks/api/v2/orderRules/useOrderRulesCreate";
import { PriceTierFormValues } from "../../../priceTiers/priceTier/PriceTierForm";

const formId = v4();

export const OrderRulesDialogCreate = ({
  active,
  onDismiss,
}: {
  active: boolean;
  onDismiss: () => void;
}) => {
  const navigate = useNavigate();

  const form = useForm<PriceTierFormValues>();

  const orderRulesCreateMutation = useOrderRulesCreate();

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={"New Order Rules"}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />

      <DialogContent className={"flex flex-col gap-2"}>
        <OrderRulesForm
          form={form}
          formId={formId}
          onSave={(data) => {
            const apiData = {
              name: data.name,
              minimumOrderPrice: data.minimumOrderPrice
                ? (formatPriceInputToApi(data.minimumOrderPrice) ?? 0)
                : 0,
            };

            orderRulesCreateMutation.mutate(apiData, {
              onSuccess: (data) => {
                navigate(ORDER_RULE.href({ orderRulesId: data.id }));
                onDismiss();
              },
            });
          }}
        />
      </DialogContent>

      <DialogCTA>
        <Button
          loading={orderRulesCreateMutation.isPending}
          disabled={!form.formState.isValid}
          type={"submit"}
          form={formId}
        >
          Create
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
